
export const getSecuredFileUrl = (filePath) => {
    let url = new URL(`${process.env.REACT_APP_BASE_API_URL}/${process.env.REACT_APP_VERSION_V1}/${filePath}`)
    return url?.href?.toString()
}

export const getFilePath = (name, project_id, item_id) => {
    let BaseUrl = new URL(`${process.env.REACT_APP_BASE_API_URL}/${process.env.REACT_APP_VERSION_V1}/file/vendor`)
    return (`${BaseUrl}/${project_id}/${item_id}/${name}`)
}
export const getFilePathForView = (name, project_id, item_id) => {
    let BaseUrl = new URL(`${process.env.REACT_APP_BASE_API_URL}/${process.env.REACT_APP_VERSION_V1}/file/vendor/read`)
    return (`${BaseUrl}/${project_id}/${item_id}/${name}`)
}


export const getFileExtension = (file = '') => file.split('?')[0].split('#')[0].split('.').pop()?.toLowerCase()

export const IMAGE_PREVIEW_TYPES = ["svg", "png", "jpg", "jpeg", "webp", "gif"]

export const isImagePreviewType = (type) => IMAGE_PREVIEW_TYPES.includes(type?.toLowerCase())

const PREVIEWABLE_FILE_TYPES = ["pdf", ...IMAGE_PREVIEW_TYPES]

export const isShowable = (file) => {
    const extention = getFileExtension(file)
    return PREVIEWABLE_FILE_TYPES.includes(extention)
}


export const getPreviewUrl = (file, project_id, item_id) => {
    const extention = getFileExtension(file)
    switch (extention) {
        case "svg":
            return getFilePath(file, project_id, item_id)
        case "png":
            return getFilePathForView(file, project_id, item_id)
        case "jpg":
            return getFilePathForView(file, project_id, item_id)
        case "jpeg":
            return getFilePathForView(file, project_id, item_id)
        case "xlsx":
            return "/icons/filetypes/xlsx.svg"
        case "csv":
            return "/icons/filetypes/xlsx.svg"
        case "ai":
            return "/icons/filetypes/ai.svg"
        case "pdf":
            return "/icons/filetypes/pdf.svg"
        default:
            return "/icons/filetypes/file.svg"
    }
}

export const getPreview = (file) => {
    if (/image\/[a-z+.-]+/.test(file.type)) {
        return file.preview
    }
    switch (file.type) {
        case "application/pdf":
            return "/icons/filetypes/pdf.svg"
        default:
            return "/icons/filetypes/file.svg"
    }
}
